import { useState, useEffect } from 'react'
import Logo from '../../dashboard/assets/logo2.png'
import Award from '../../dashboard/assets/award.png'

const RightSideBar = () => {
  const [show, setShow] = useState(false)

  return (
    <>
      <div className="bg-transparent h-screen lg:w-[350px] text-wrap px-4">
        <div className="bg-white h-auto w-auto flext justify-center p-4">
          <div>
            <div className="mb-8">
              <img src={Logo} alt="" />
            </div>

            <div>
              <img src={Award} alt="" />
            </div>
            <p className=""></p>
          </div>
        </div>
        <div className="h-4"></div>
        <div className="bg-white h-auto w-auto flext justify-center p-4">
          <h1 className="font-bold mb-4">Testimonials</h1>
          <div>
            <h4>Mr Mmadike Christopher George</h4>
            <hr />
            <p className="mt-2">
              I have been doing business with Optiva for about 2 years now and
              there have been no problems. Their services are okay. Their
              services are excellent. I did my investigations about Optiva and
              found out that they are reliable. I have some friends that have
              done transactions with them and the transactions were very
              successful
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default RightSideBar
